import React from 'react';
import { DINEIN_THEME_COLORS, DineInMenuTheme } from '../hooks/useDineInMenuTheme';

type Props = {
  theme: DineInMenuTheme;
  fadeMs: number;
  children: React.ReactNode;
  className?: string;
};

/** Два фоновых слоя с crossfade — без мигания сплошной заливки */
export function DineInThemeShell({ theme, fadeMs, children, className = '' }: Props) {
  const isLight = theme === 'light';

  return (
    <div className={`landing-root dinein-theme-shell relative ${className}`} data-theme={theme}>
      <div
        aria-hidden
        className="dinein-theme-bg"
        style={{
          backgroundColor: DINEIN_THEME_COLORS.darkBg,
          opacity: isLight ? 0 : 1,
          transition: `opacity ${fadeMs}ms ease`,
        }}
      />
      <div
        aria-hidden
        className="dinein-theme-bg"
        style={{
          backgroundColor: DINEIN_THEME_COLORS.lightBg,
          opacity: isLight ? 1 : 0,
          transition: `opacity ${fadeMs}ms ease`,
        }}
      />
      <div className="relative z-[1] min-h-screen flex flex-col">{children}</div>
    </div>
  );
}
